/*!
=========================================================
* Material Dashboard PRO React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { GlobalProvider } from "./GlobalContext.js";
import ScrollToTop from "customComponents/ScrollToTop.js";
import logo from "assets/img/logo.png";

import MainLayout from "layouts/Main.js";

import "assets/scss/material-dashboard-pro-react.scss?v=1.10.0";

import "./i18n/config";

ReactDOM.render(
  <GlobalProvider>
    <Suspense
      fallback={
        <div
          style={{
            position: "fixed",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: "#fff",
            zIndex: 9999,
          }}
        >
          <img
            src={logo}
            alt="logo"
            style={{
              width: 80,
              height: 80,
              marginBottom: 20,
              animation: "logoPulse 1.6s ease-in-out infinite",
              // La animación está definida en "src/assets/scss/material-dashboard-pro-react.scss"
            }}
          />
          <div>Loading...</div>
        </div>
      }
    >
      <BrowserRouter basename="/">
        <ScrollToTop />
        <Switch>
          <Redirect exact from="/" to="/guide" />
          <Route path="/" component={MainLayout} />
        </Switch>
      </BrowserRouter>
    </Suspense>
  </GlobalProvider>,
  document.getElementById("root")
);